import { validateToken, getUserData } from "../../../../../auth/views/login/auth.api.js";

const { token, parentCustomerId } = getUserData() || {};

const baseUrl = 'https://dashboard.pressuretrack.co.za/api';

const fetchOptions = {
  method: 'GET',
  headers: {
    'Authorization': `Bearer ${token}`,
    'Accept': 'application/json'
  },
  credentials: 'include' // only if needed
};

const userData = JSON.parse(localStorage.getItem('userData'));
if (userData) {
  const token = userData.token;
  let parentCustomerId = userData.customer;
  if (!parentCustomerId) {
    const customerToken = validateToken();
    parentCustomerId = customerToken?.decodedToken?.user?.customerId;
  }
}

export const fetchRepeaters = async (unit) => {
  try {

    const apiUrl = unit
      ? `${baseUrl}/customer/${unit.customerId}/repeater?unitId__oid=${unit.Id}`
      : `${baseUrl}/customer/${parentCustomerId}/repeater?inclChild=true&limit=0`;
    const response = await fetch(apiUrl, fetchOptions);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data.count ? data.results : [];

  } catch (e) {
    console.error('repeatersJS: fetchRepeaters - ERROR ', e);
  }
};

export const createRepeater = async (customerId, repeater) => {

  const apiUrl = `${baseUrl}/customer/${customerId}/repeater`;
  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({
      Id: repeater.Id,
      unitId: repeater.unitId,
      unitType: repeater.unitType
        ? repeater.unitType.charAt(0).toUpperCase() + repeater.unitType.slice(1).toLowerCase()
        : null,
      config: repeater.config
    })
  });
  if (!response.ok) {
    const errorDetails = await response.json();
    console.error(`Failed to create repeater: ${response.statusText} - ${JSON.stringify(errorDetails)}`);
    return;
  }
  console.log("Repeater created:", await response.json());
};

export const updateRepeater = async (customerId, repeater) => {

  const response = await fetch(`${baseUrl}/customer/${customerId}/repeater/${repeater.Id}`, {
    method: "PATCH",
    headers: {
      'Authorization': `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({
      unitId: repeater.unitId,
      unitType: repeater.unitType
        ? repeater.unitType.charAt(0).toUpperCase() + repeater.unitType.slice(1).toLowerCase()
        : null,
      config: repeater.config
    })
  });

  if (!response.ok) {
    const errorDetails = await response.json();
    console.error("Failed to update repeater:", response.status, errorDetails);
    throw new Error(`Failed to update repeater: ${response.statusText}`);
  }
  console.log("Repeater updated:", await response.json());
};

export const deleteRepeater = async (customerId, repeaterId) => {
  const apiUrl = `${baseUrl}/customer/${customerId}/repeater/${repeaterId}`;

  try {
    const response = await fetch(apiUrl, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      credentials: 'include'
    });

    if (!response.ok) {
      // Handle errors (e.g., repeater not found, unauthorized, etc.)
      const errorDetails = await response.json();
      console.error("Error deleting repeater:", errorDetails);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Parse and return the JSON response for a successful request
    const responseData = await response.json();
    console.log("Repeater deleted successfully:", responseData);
    return responseData;

  } catch (error) {
    console.error("An error occurred:", error.message);
    throw error;
  }
};

export const fetchRepeaterHistoryData = async (imei, repeaterLocation) => {

  const apiUrl = `${baseUrl}/unit/${imei}/repeater/${repeaterLocation}/history?datapointInterval=1`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();

  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
};

export const fetchSignalBoosterHistoryData = async (imei) => {

  const apiUrl = `${baseUrl}/unit/${imei}/signal-booster/history?datapointInterval=1`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();

  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
};

export const fetchRepeaterHistoryDataStandAlone = async (unitId, repeaterLocation) => {

  const apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/repeater/${repeaterLocation}/history?datapointInterval=1`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include' // Include cookies in the request
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();

  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
};

export const fetchSignalBoosterHistoryDataStandAlone = async (unitId) => {

  const apiUrl = `${baseUrl}/unit/standalone/Trailer/${unitId}/signal-booster/history?datapointInterval=1`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      credentials: 'include' // Include cookies in the request
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();

  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
};

export const createSignalBooster = async (customerId, booster) => {

  const apiUrl = `${baseUrl}/customer/${customerId}/booster`;
  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({
      Id: booster.Id,
      unitId: booster.unitId,
      unitType: booster.unitType
    })
  });
  if (!response.ok) {
    const errorDetails = await response.json();
    throw new Error(`Failed to create signal booster: ${response.statusText} - ${JSON.stringify(errorDetails)}`);
  }
  console.log("Signal booster created:", await response.json());
};

export const deleteSignalBooster = async (customerId, boosterId) => {

  const apiUrl = `${baseUrl}/customer/${customerId}/booster/${boosterId}`;
  const response = await fetch(apiUrl, {
    method: "DELETE",
    headers: {
      'Authorization': `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: 'include'
  });
  if (!response.ok) {
    const errorDetails = await response.json();
    throw new Error(`Failed to DELETE signal booster: ${response.statusText} - ${JSON.stringify(errorDetails)}`);
  }
  console.log("Signal booster deleted:", await response.json());
};

export const fetchSignalBoosters = async (c) => {

  const apiUrl = `${baseUrl}/customer/${parentCustomerId}/booster?inclChild=true`;

  try {
    const response = await fetch(apiUrl, fetchOptions);

    if (!response.ok) {
      const errorDetails = await response.json();
      throw new Error(`Failed to fetch signal booster: ${response.statusText} - ${JSON.stringify(errorDetails)}`);
    }
    const data = await response.json();
    return data.results;

  } catch (err) {
    console.log(err);
    return null;
  }
};

export const clearRepeaterAssignment = async (customerId, repeaterId) => {
  const response = await fetch(`${baseUrl}/customer/${customerId}/repeater/${repeaterId}`, {
    method: "PATCH",
    headers: {
      'Authorization': `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({
      unitId: null,
      unitType: null,
      config: {}
    })
  });

  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    console.error("Failed to clear repeater assignment:", response.status, errorDetails);
    throw new Error(`Failed to clear Location Sensor ${repeaterId}`);
  }

  return await response.json();
};

export const fetchSignalBooster = async (customerId, boosterId) => {

  const apiUrl = `${baseUrl}/customer/${customerId}/booster/${boosterId}`;

  try {
    const response = await fetch(apiUrl, fetchOptions);

    if (!response.ok) {
      const errorDetails = await response.json();
      console.error(`Failed to get signal booster ${boosterId}: ${response.statusText} - ${JSON.stringify(errorDetails)}`);
      return null;
    }
    return await response.json();

  } catch (err) {
    console.log(err);
    return null;
  }

};

